import Ajax from 'global/od/Ajax';

export const addToCartTagging = newSignalData => {
	// TODO Data comes from server so needs to be call something more generic like in signalData.tag

	if (newSignalData) {
		window.signalEvent = window.signalEvent || {};
		window.signalEvent.addToCart = newSignalData.addToCart;

		if (window.od) {
			window.od.journeyData = window.od.journeyData || {};

			// Set to match how window.od.journeyData.basket is structured
			window.od.journeyData.addToCart = {
				products: newSignalData.addToCart,
			};
		}

		window.signalData = window.signalData || {};
		window.signalData.navigation = window.signalData.navigation || {};

		updateSignalObject(newSignalData);
		window.signalData.navigation.currentUrl = window.location.href;
	} else {
		window.signalData.navigation.pageType = 'atb-lightbox';
	}
	window.signalData.navigation.pageName = 'Add To Basket Layover';

	/** Used by internal modules such as crossSellZones and MiniCart */
	triggerEvent('cartUpdated', newSignalData);

	/** These two events are defined from within Signal, not the codebase */
	triggerEvent('signalAddToCart');
	triggerEvent('signalAsyncPage');

	consoleInfo(
		'TAGGING',
		'add to cart event: ',
		window.signalData,
		window.signalEvent,
	);
};

const updateSignalObject = newSignalData => {
	window.signalData = Object.assign({}, window.signalData, newSignalData);

	if (window.signalData.navigation.loginSuccess)
		delete window.signalData.navigation.loginSuccess;

	return window.signalData;
};

export function thirdPartyTracking(url) {
	Ajax.external({
		method: 'GET',
		url,
	}).catch(error => {
		console.error('Error sending tracking tag: ', url, error); // eslint-disable-line no-console
	});
}

const triggerEvent = (eventName, data) => {
	try {
		document.dispatchEvent(new CustomEvent(eventName, { detail: data }));
	} catch (analyticsError) {
		catchError('Analytics Error: ', analyticsError);
	}
};

const catchError = (...error) => {
	// eslint-disable-next-line no-console
	if (console && console.error) {
		console.error(...error); // eslint-disable-line no-console
	}
};

const consoleInfo = (...info) => {
	// eslint-disable-next-line no-console
	if (console && console.info) {
		console.info(...info); // eslint-disable-line no-console
	}
};
